import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/context/authContext";
import { assignAuthority, endAuthority } from "@/Services/institutions.service";
import type { InstitutionScope } from "../types";

export function useInstitutionAuthorityMutations(institutionId: string) {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: ["institution-authorities", institutionId] });

  async function assign(params: {
    positionTypeId: string;
    scope: InstitutionScope;
    regionId?: string | null;
    districtId?: string | null;
    ministerId?: string | null;
    institutionMemberId?: string | null;
    startedAt: string;
  }) {
    if (!user) throw new Error("Not authenticated");
    await assignAuthority({ ...params, institutionId, userId: user.id });
    await invalidate();
  }

  async function end(authorityId: string, endedAt: string) {
    if (!user) throw new Error("Not authenticated");
    await endAuthority(authorityId, endedAt, user.id);
    await invalidate();
  }

  return { assign, end };
}
